export default [
	{ name: 'Red', value: '#dd2c00' },
	{ name: 'Crimson', value: '#dc143c' },
	{ name: 'Salmon', value: '#fa8072' },
	{ name: 'Firebrick', value: '#b22222' },
	{ name: 'Pink', value: '#ffc0cb' },
	{ name: 'Fushia', value: '#ff00ff' },
	{ name: 'Medium-Violet Red', value: '#c71585' },
	{ name: 'Purple', value: '#800080' },
	{ name: 'Turquoise', value: '#40e0d0' },
	{ name: 'Baby Blue', value: '#00bcd4' },
	{ name: 'Slate Blue', value: '#6A5acd' },
	{ name: 'Steel Blue', value: '#4682B4' },
	{ name: 'Blue', value: '#0779e4' },
	{ name: 'Dark Blue', value: '#084177' },
	{ name: 'Yello', value: '#fcbf1e' },
	{ name: 'Gold', value: '#ffd700' },
	{ name: 'Orange', value: '#fc7e2f' },
	{ name: 'Spring Green', value: '#00ff7f' },
	{ name: 'Lime Green', value: '#32cd32' },
	{ name: 'Green', value: '#008000' },
	{ name: 'Olive', value: '#808000' },
	{ name: 'Teal', value: '#008080' },
	{ name: 'Dark Green', value: '#006400' },
	{ name: 'Gray', value: '#808080' },
	{ name: 'Slate Gray', value: '#708090' },
	{ name: 'Black', value: '#000000' }
];
